/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2021-05-25 19:19:46
 * @LastEditors: xiawenlong
 * @LastEditTime: 2023-10-19 17:52:44
 */
import axios from "axios";
import router from "../router";
import { getCookie, removeCookie } from "@/utils/cookies";
import { Message } from "element-ui";
//添加请求拦截器
axios.interceptors.request.use(
  function(config) {
    // 将token给到一个前后台约定好的key中，作为请求发送
    let token = getCookie("myToken");
    let ip = localStorage.getItem("ip");
    // console.log(config)
    // if (token) {
    // config.headers.Authorization = token
    config.headers = {
      authorization: token,
      "Content-Type": "application/json",
      timestamp: "",
      version: "",
      client: "manage",
      terminal: "Web/Mini",
      "x-api-version": "1.0.0",
      ip: ip,
      platform: "WEB"
    };
    // store.commit('startLoading');
    // }
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

//添加响应拦截器
axios.interceptors.response.use(
  response => {
    // 对响应数据做些事
    // let token = sessionStorage.getItem('myToken');
    // if(token){
    // store.commit('closeLoading');
    // }
    // if(response.data.code == "SYS2003" || response.data.code == "GW1000"){
    //     sessionStorage.clear()
    // }
    if (response.data.code == 100104) {
      removeCookie("myToken");
      // window.location.href =
      //   "https://" + window.location.host + "/introduceHome";

      router.push({
        path: "/introduceHome"
      });
    }
    if (response.data.code == 100105) {
      removeCookie("myToken");
      // window.location.href =
      //   "https://" + window.location.host + "/introduceHome";
      router.push({
        path: "/introduceHome"
      });
    }
    if (response.data.code == 101246) {
      removeCookie("myToken");
      Message({
        type: "warning",
        message: response.data.msg
      });
      router.push({
        path: "/introduceHome"
      });
      return;
    }
    return response;
  },
  error => {
    console.log(error, "error");
    // 请求错误时做些事
    // console.log(error)
    if (error.response) {
      // switch (error.response.status) {
      //   case 404:
      //   // 返回 401 清除token信息并跳转到登录页面
      //   MessageBox.alert('您的数据异常，请联系管理员', {
      //       confirmButtonText: '确定',
      //       showClose:false,
      //       callback: action => {
      //           sessionStorage.clear()
      //       }
      //   });
      //   // router.replace({
      //   //   path: 'login',
      //   //   query: {redirect: router.currentRoute.fullPath} // 登录成功后跳入浏览的当前页面
      //   // })
      //   break;
      // }
    }
    return Promise.reject(error.response); // 返回接口返回的错误信息
  }
);



// WEBPACK FOOTER //
// ./src/api/http.js